import { format, isAfter, parseISO, set, startOfDay } from 'date-fns'
import { useLocale } from 'next-intl'

export const formatDateRange = (dateRange: [Date | null, Date | null]) => {
  let startDate = dateRange[0] ? dateRange[0] : null
  let endDate = dateRange[1] ? dateRange[1] : null
  let startISO = startDate ? format(startDate, 'yyyy-MM-dd') + 'T00:00:00' : ''
  let endISO = endDate ? format(endDate, 'yyyy-MM-dd') + 'T23:59:59' : ''

  if (!startISO && !endISO) {
    return ''
  } else {
    if (startDate && !endISO) {
      endISO = format(startDate, 'yyyy-MM-dd') + 'T23:59:59'
    }
    if (!startISO && endDate) {
      startISO = format(endDate, 'yyyy-MM-dd') + 'T00:00:00'
    }
  }

  return `${startISO},${endISO}`
}

export const isCurrentDateHigher = (date: string) => {
  const currentDate = startOfDay(new Date())
  const parseDate = startOfDay(parseISO(date))
  return isAfter(currentDate, parseDate)
}

export const formatInvoiceDate = (
  invoiceMonth: number,
  invoiceYear: number,
  isPDF: boolean = false,
  dateShortOrLong: 'long' | 'short' = 'short'
): string => {
  const date = new Date(invoiceYear, invoiceMonth - 1, 1)
  let locale
  if (isPDF) {
    locale = 'en-US'
  } else {
    locale = useLocale()
  }

  return new Intl.DateTimeFormat(locale, {
    month: dateShortOrLong === 'short' ? 'short' : 'long',
    year: 'numeric',
  }).format(date)
}
